import { useRef, useState } from "react";
import ActivityType from "types/ActivityType";
import { Menu, Transition } from "@headlessui/react";
import Icon from "hardcover-ui/components/Icon";
import faEllipsisH from "icons/regular/ellipsis.svg";
import faFlag from "icons/solid/flag.svg";
import faShare from "icons/solid/share.svg";
import { usePopper } from "react-popper";
import { Link } from "@inertiajs/react";
import DeleteMenuButton from "./ActivityOptions/DeleteMenuButton";
import ReportButton from "components/ReportDropdown/Report/ReportButton";

export interface Props {
  activity: ActivityType;
  onDelete: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function ActivityOptions({ activity, onDelete }: Props) {
  const [buttonReferenceElement, setButtonReferenceElement] = useState(null);
  const [buttonPopperElement, setButtonPopperElement] = useState(null);
  const buttonElRef = useRef(null);

  const { styles: buttonStyles, attributes: buttonAttributes } = usePopper(
    buttonReferenceElement,
    buttonPopperElement,
    {
      placement: "bottom-start",
      modifiers: [
        {
          name: "offset",
          enabled: true,
          options: {
            offset: [0, -1],
          },
        },
      ],
    }
  );

  return (
    <Menu
      as="div"
      className="md:relative block md:inline-block text-left z-auto"
    >
      {({ close }) => (
        <>
          <Menu.Button>
            <div ref={setButtonReferenceElement}>
              <Icon
                icon={faEllipsisH}
                size="lg"
                className="text-tertiary hover:text-foreground transition-colors"
              />
            </div>
          </Menu.Button>
          <div
            className="z-20"
            ref={buttonElRef}
            style={buttonStyles.popper}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...buttonAttributes.popper}
          >
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
              beforeEnter={() => setButtonPopperElement(buttonElRef.current)}
              afterLeave={() => setButtonPopperElement(null)}
            >
              <Menu.Items
                static
                className=" md:w-48 rounded-md shadow-lg bg-background ring-2 ring-secondary ring-opacity-5 divide-y divide-secondary focus:outline-none overflow-hidden transition-colors"
              >
                <ReportButton
                  objectId={activity.id}
                  objectType="Activity"
                  description={`Activity: #${activity.id}`}
                  className="cursor-pointer w-full  group flex items-center px-4 py-2 text-sm text-foreground hover:bg-primary hover:text-primary-foreground font-semibold justify-between space-x-4 "
                  close={close}
                >
                  <span>Report Activity</span>
                  <Icon icon={faFlag} size="lg" />
                </ReportButton>

                <Menu.Item>
                  <Link
                    href={`/@${activity.user.username}/activity/${activity.id}`}
                    className="cursor-pointer w-full group flex items-center px-4 py-2 text-sm  text-foreground hover:bg-primary hover:text-primary-foreground font-semibold justify-between "
                  >
                    <span>Share</span>
                    <Icon icon={faShare} size="lg" />
                  </Link>
                </Menu.Item>
                <DeleteMenuButton activity={activity} onDelete={onDelete} />
              </Menu.Items>
            </Transition>
          </div>
        </>
      )}
    </Menu>
  );
}
